import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';
import NotificationActions from './NotificationActions';
import { ErrorProvider } from '../../../libraries/branch-tooling-next/Error/ErrorProvider';

const errorProvider = new ErrorProvider();

const DeleteDeepview = new ReduxAsyncAction('DEEPVIEW_DELETE');
DeleteDeepview.registerRequest(function (name) {
  return dash_api.delete(`/v1/deepview/${name}`).then((res) => {
    return { id: name };
  });
});
export const deleteDeepview = DeleteDeepview.request;
export const DEEPVIEW_DELETE = DeleteDeepview.constants;

const GetDeepview = new ReduxAsyncAction('DEEPVIEW_GET');
GetDeepview.registerRequest(function (name) {
  return dash_api.get(`/v1/deepview/${name}`).then((res) => {
    return { deepview: res.data };
  });
});
export const getDeepview = GetDeepview.request;
export const DEEPVIEW_GET = GetDeepview.constants;

const ListDeepview = new ReduxAsyncAction('DEEPVIEW_LIST');
ListDeepview.registerRequest(function () {
  return dash_api.get(`/v1/deepview`).then((res) => {
    return { deepviews: res.data };
  });
});
export const listDeepview = ListDeepview.request;
export const DEEPVIEW_LIST = ListDeepview.constants;

const SaveDeepview = new ReduxAsyncAction('DEEPVIEW_SAVE');
SaveDeepview.registerRequest((deepview) => {
  return dash_api
    .post(`/v1/deepview`, deepview)
    .then((res) => {
      return { deepview: res.data };
    })
    .catch((err) => {
      let errorMessage = 'Failed to save deepview.';
      const errName = errorProvider.parse(err).getResponse()?.data?.name;
      if (errName === 'deepview_contains_unsafe_values') {
        errorMessage = 'Deepview contains an unsafe value - "data:", "vbscript:", or "ftp:"';
      } else if (errName === 'deepview_template_validation') {
        errorMessage = 'Deepview contains an unsafe value';
      }
      NotificationActions.showNotification(errorMessage, 'error');
      throw err;
    });
});
export const saveDeepview = SaveDeepview.request;
export const DEEPVIEW_SAVE = SaveDeepview.constants;

const CreateDeepview = new ReduxAsyncAction('DEEPVIEW_CREATE');
CreateDeepview.registerRequest(function (name) {
  return dash_api.get(`/v1/deepview/clone?name=${name}`).then((res) => {
    return { deepview: res.data };
  });
});
export const createDeepview = CreateDeepview.request;
export const DEEPVIEW_CREATE = CreateDeepview.constants;

// Track which deepview is currently marked for deletion
export const PROMPT_DEEPVIEW_DELETE = 'DEEPVIEW_DELETE_PROMPT';

export function promptDeepviewDelete(name) {
  return {
    type: PROMPT_DEEPVIEW_DELETE,
    data: { open: true, name },
  };
}

// When use cancels the modal confirming for cancel
export const PROMPT_CANCEL = 'DEEPVIEW_CANCEL_PROMPT';

export function promptCancel() {
  return {
    type: PROMPT_CANCEL,
    data: { open: false, name: null },
  };
}

export const PROMPT_DEEPVIEW_ENABLE = 'DEEPVIEW_ENABLE_PROMPT';

export function promptDeepviewEnable(enable_name) {
  return {
    type: PROMPT_DEEPVIEW_ENABLE,
    data: { enable_open: true, enable_name },
  };
}

export const PROMPT_ENABLE_CANCEL = 'DEEPVIEW_CANCEL_ENABLE_PROMPT';

export function promptEnableCancel() {
  return {
    type: PROMPT_ENABLE_CANCEL,
    data: { enable_open: false, enable_name: null },
  };
}
